import React from 'react';
import PropTypes from 'prop-types';


import * as browserUtils from '../../../utils/browserUtils';
import * as styleUtils from '../../../utils/styleUtils';

import {JumpToTop} from '../../global';
import {ToastMessages} from '../../contexts/Notification';
import {useIsAuthenticated} from '../../contexts/Auth';

import Footer from './Footer';
import Header from './Header';

import styles from './StandardLayout.scss';


function StandardLayout({children}) {

    const isAuthenticated = useIsAuthenticated();

    return (
        <React.Fragment>

            <Header/>

            {isAuthenticated && <ToastMessages/>}

            <div className={styleUtils.toClasses(styles.layoutContent, isAuthenticated ? styles.loggedIn : null, 'body', browserUtils.isWindows() ? 'os-windows' : null)}>
                {children}
            </div>

            <JumpToTop/>

            <Footer/>

        </React.Fragment>
    );
}


StandardLayout.propTypes = {
    children: PropTypes.any
};


export default StandardLayout;
